/**
 * Providers and hosts that sit around the whole shell because both the chrome
 * and the page use them (prototype: the context stack in App.tsx).
 */
import { lazy, Suspense, type ReactNode } from 'react';

import { ConversationsProvider } from '@/features/conversations';

const InviteMemberHost = lazy(() =>
  import('@/features/settings/InviteMemberHost').then((module) => ({
    default: module.InviteMemberHost,
  })),
);

/*
 * The sidebar's `Invite member` dialog, in both trees. Lazy, so its code stays
 * off the initial path. It was mounted under /test only until 2026-10-26,
 * which left the live sidebar's button opening nothing.
 */
export function ShellProviders({ children }: { children: ReactNode }) {
  return (
    <ConversationsProvider>
      {children}
      <Suspense fallback={null}>
        <InviteMemberHost />
      </Suspense>
    </ConversationsProvider>
  );
}
